import React from 'react';

import ContentfulImage from '../ContentfulImage';
import * as styles from './EmbeddedEntries.module.css';

export const simpleMediaGroup = (node) => {
  const images = node?.data?.target?.media;
  if (!images) return null;
  return (
    <div className={styles.media}>
      {images.map((media, i) => {
        return <ContentfulImage className={styles.img} imageFragment={media} key={i} />;
      })}
    </div>
  );
};
